import React from 'react';
import { Breadcrumb } from 'antd';
import { createUuid } from '../../../utils/NHCore';

class NHNavigationBar extends React.Component {
    constructor() {
        super()
        this.state = {

        }
    }
    render() {
        return (
            <div id='Breadcrumb'>
                <Breadcrumb>
                    {this.props.breadcrumbList.map(item => (
                        <Breadcrumb.Item key={item.key}>{item.name}</Breadcrumb.Item>
                    ))}
                </Breadcrumb>
            </div>
        )
    }
}
export default NHNavigationBar;


// WEBPACK FOOTER //
// ./components/common/NHNavigationBar/index.js